// Living World — pure score→atmosphere translator for the Wellness IQ hub.
// No JSX here; components map `weather` strings to lucide icons.

export const PILLAR_WORLD = {
  movement:  { key: 'movement',  label: 'Move',    color: '#CCFF00', route: '/performance', insightKey: 'movement_insight' },
  recovery:  { key: 'recovery',  label: 'Recover', color: '#22d3ee', route: '/recovery',    insightKey: 'recovery_insight' },
  mental:    { key: 'mental',    label: 'Mind',    color: '#a855f7', route: '/mental',       insightKey: 'mental_insight' },
  nutrition: { key: 'nutrition', label: 'Fuel',    color: '#fb923c', route: '/nutrition',    insightKey: 'nutrition_insight' },
};

export const PILLAR_ORDER = ['movement', 'recovery', 'mental', 'nutrition'];

// Band → mood. `light` (0–1) drives glow/brightness, `fog` (0–1) drives the
// drifting haze. `weather` maps to a lucide line-icon in the tile.
export function moodForScore(score) {
  if (score === null || score === undefined)
    return { band: 'unknown', state: 'Asleep', weather: 'moon', light: 0, fog: 0.45 };
  const s = Math.max(0, Math.min(100, score));
  if (s < 40) return { band: 'dormant',  state: 'Dormant',  weather: 'fog',      light: 0.06, fog: 0.92 };
  if (s < 60) return { band: 'stirring', state: 'Stirring', weather: 'cloud',    light: 0.30, fog: 0.55 };
  if (s < 80) return { band: 'steady',   state: 'Steady',   weather: 'cloudsun', light: 0.60, fog: 0.22 };
  return                { band: 'thriving', state: 'Thriving', weather: 'sun',    light: 1.0,  fog: 0.0 };
}

// Whole-world "time of day" sky tint, driven by the composite Wellness IQ.
// Tops are lifted enough that the world reads as a distinct surface against the
// near-black page background at every band (not just the extremes).
export function skyForOverall(overall) {
  if (overall === null || overall === undefined)
    return { name: 'night',  top: '#141a28', bottom: '#0a0e18' };
  const s = Math.max(0, Math.min(100, overall));
  if (s < 40) return { name: 'night',  top: '#141a28', bottom: '#0a0e18' };
  if (s < 60) return { name: 'dawn',   top: '#241e36', bottom: '#0f0d1c' };
  if (s < 80) return { name: 'day',    top: '#172c39', bottom: '#0c1620' };
  return                { name: 'bright', top: '#193322', bottom: '#0d1710' };
}

// Deterministic fallback phrase per band, so a tile is never empty.
export const BAND_FALLBACK = {
  dormant:  'needs attention',
  stirring: 'warming up',
  steady:   'holding steady',
  thriving: 'in great shape',
  unknown:  'no reading yet',
};

export function clampPhrase(text, max = 54) {
  if (!text) return null;
  const t = String(text).trim().replace(/\s+/g, ' ');
  return t.length <= max ? t : t.slice(0, max - 1).trimEnd() + '…';
}
